import { render, staticRenderFns } from "./download-proposal-button.vue?vue&type=template&id=21604834&"
import script from "./download-proposal-button.vue?vue&type=script&lang=js&"
export * from "./download-proposal-button.vue?vue&type=script&lang=js&"
import style0 from "./download-proposal-button.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports